import { render, staticRenderFns } from "./approval_view.vue?vue&type=template&id=75494054&scoped=true"
import script from "./approval_view.vue?vue&type=script&lang=js"
export * from "./approval_view.vue?vue&type=script&lang=js"
import style0 from "./approval_view.vue?vue&type=style&index=0&id=75494054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75494054",
  null
  
)

export default component.exports